import React, {useState} from 'react'
import {AddItemToExistingList} from './AddItemToExistingListModalView'
import {AddItemToNewList} from './AddItemToNewListModalView'
import CustomModal from '../../../../genericComponents/CustomModal'
import './AddItemToListModal.scss'
import {IdType} from '../../../../util/models/IdType'

const ItemSearchModal = ({
                             itemIds,
                             closeModal,
                         }: {
    closeModal: () => void, itemIds: IdType[]}) => {
    enum ItemSearchModalStateEnum {
        ADD_TO_EXISTING = 'ADD_TO_EXISTING',
        ADD_TO_NEW = 'ADD_TO_NEW',
        CONFIRMATION = 'CONFIRMATION'
    }

    const [itemModalState, setItemModalState] = useState<ItemSearchModalStateEnum>(ItemSearchModalStateEnum.ADD_TO_EXISTING)

    return (<CustomModal handleClose={closeModal}>
        {itemModalState === ItemSearchModalStateEnum.ADD_TO_EXISTING &&
            <AddItemToExistingList handleSubmit={() => setItemModalState(ItemSearchModalStateEnum.ADD_TO_NEW)}
                                   itemIds={itemIds}/>}
        {itemModalState === ItemSearchModalStateEnum.ADD_TO_NEW &&
            <AddItemToNewList handleSubmit={() => setItemModalState(ItemSearchModalStateEnum.ADD_TO_EXISTING)}
                              itemIds={itemIds}/>}
    </CustomModal>)
}

export default ItemSearchModal
